// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { t16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-t': IconT;
    }
}

/**
 * The icon component for the 't' icon
 */
export class IconT extends IconSvg {
    public constructor() {
        super(t16X16);
    }
}

registerIconSvg('icon-t', IconT);
export const iconTTag = 'nimble-icon-t';
